export const WELCOME_FALLBACK_CODE = "W15-WELFLAPR26"
export const WELCOME_FALLBACK_DESCRIPTION = "Save an Extra 15%"
